import { Box, Button, DialogContent } from "@material-ui/core";
import { UpdateableColumn } from "./csvColumns";
import { useTranslation } from "react-i18next";

type Params = {
  selected: UpdateableColumn[];
  onChange: () => void;
};

export default function SelectedColumns({ selected, onChange }: Params) {
  const { t } = useTranslation("accounts");
  const columns = useTranslateColumns(selected);

  return (
    <DialogContent>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p="1rem"
        style={{
          border: "1px solid rgba(0, 0, 0, 0.20)",
          borderRadius: "6px",
        }}
      >
        {t("modal.selectColumn.selected", {
          columns: [t("column.email"), ...columns].join(", "),
        })}
        <Button size="small" color="primary" onClick={onChange}>
          {t("modal.selectColumn.change")}
        </Button>
      </Box>
    </DialogContent>
  );
}

function useTranslateColumns(columns: UpdateableColumn[]) {
  const { t } = useTranslation("accounts");
  return columns.map(c => t(`column.${c}`));
}
